import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from 'firebase/firestore'

import { db } from 'utils/firebase'

import { Follow } from 'types/follow'
import { Data } from 'types/query'

import { formatDocSnapshot, formatQuerySnapshot } from './formatFirestoreResults'

export const postFollow = async (data: Data) => {
  const { follower, trainer } = data
  const userId = follower?.id
  const trainerId = trainer?.id

  const follow = await fetchFollow({ userId, trainerId })
  if (follow) {
    return follow
  }
  const newFollowRef = await addDoc(collection(db, 'follows'), {
    follower,
    trainer,
  })
  const newFollow = await getDoc(newFollowRef)
  return formatDocSnapshot(newFollow)
}

export const fetchFollow = async (data: Data): Promise<Follow | null> => {
  const { userId, trainerId } = data

  if (!userId || !trainerId) return null

  const q = query(
    collection(db, 'follows'),
    where('trainer.id', '==', trainerId),
    where('follower.id', '==', userId),
  )
  const querySnapshot = await getDocs(q)
  const results = formatQuerySnapshot(querySnapshot)
  if (results.length === 0) return null
  return results[0]
}

export const fetchFollows = async (data: Data): Promise<Array<Follow> | []> => {
  const { userId } = data

  if (!userId) return []
  const q = query(collection(db, 'follows'), where('follower.id', '==', userId))
  const querySnapshot = await getDocs(q)
  return formatQuerySnapshot(querySnapshot)
}

export const fetchFollowers = async (data: Data): Promise<Array<Follow> | []> => {
  const { userId } = data

  if (!userId) return []
  const q = query(collection(db, 'follows'), where('trainer.id', '==', userId))
  const querySnapshot = await getDocs(q)
  return formatQuerySnapshot(querySnapshot)
}

export const deleteFollow = async (data: Data) => {
  const { followId } = data
  const followRef = doc(db, 'follows', followId)
  await deleteDoc(followRef)
}
